import type { AISidekickChatState } from '../state/chatTypes';

/** Compares message identity without depending on mutable message contents. */
export const haveSameMessageIds = (
  left: ReadonlyArray<{ id: string }>,
  right: ReadonlyArray<{ id: string }>
): boolean =>
  left.length === right.length &&
  left.every((message, index) => message.id === right[index]?.id);

/** Checks whether an identifier already belongs to the active local lineage. */
export const isKnownConversationId = (
  state: AISidekickChatState,
  conversationId: string
): boolean =>
  state.conversationId === conversationId ||
  state.branchSession.branchesByConversationId[conversationId] !== undefined;

/**
 * Checks that no parent-conversation work superseded an asynchronous branch
 * request.
 */
export const isConversationBranchParentCurrent = (
  state: AISidekickChatState,
  parentConversationId: string,
  parentMessages: ReadonlyArray<{ id: string }>
): boolean =>
  state.conversationId === parentConversationId &&
  !state.isStreaming &&
  state.pendingHostUserMessage === null &&
  haveSameMessageIds(state.messages, parentMessages);
